/**
 * Module-level interaction flag updated synchronously during window drag/resize.
 * Lets OsWindow skip focus updates without subscribing to a React context that
 * would re-render every window on each interaction start/stop.
 */
export const osInteractionRef = { current: false };
